/**
 * @ngdoc directive
 * @name formfile
 *
 * @description
 * File upload component
 */
module.directive('formFile', function () {
    'use strict';
    return {
        restrict: 'EA',
        require: '^ngModel',
        replace: true,
        scope: {
            name: '@',
            type: '@?',
            currentfile: '=',
            label: '@',
            labeladd: '@'
        },
        controller: ['$scope', '$filter', 'CustomFileUploader', function ($scope) {
            $scope.$errors = [];

            $scope.pending = false;
        }],
        link: function (scope, element, attrs, ngModel) {
            var input = element.find('input');

            function readFiles(ngModelValue, files) {
                if (files.length > 0) {
                    var file = files.shift();
                    var reader = new FileReader();
                    reader.readAsDataURL(file);

                    reader.onload = function() {
                        ngModelValue.push({
                            filename: file.name,
                            filemime: file.type,
                            size: file.size,
                            data: reader.result.split(',')[1]
                        });
                        readFiles(ngModelValue, files);
                    };
                }
                else {
                    ngModel.$setViewValue(ngModelValue);
                }
            }

            element.on('dragover', function(event) {
                event.preventDefault();
                return false;
            });

            element.on('drop', function(event) {
                event.preventDefault();
                var files = [];
                var dt = event.dataTransfer;
                if (dt.items) {
                    angular.forEach(dt.items, function(item) {
                        if (item.kind === 'file') {
                            files.push(item.getAsFile());
                        }
                    });
                }
                else {
                    angular.forEach(dt.files, function(file) {
                        files.push(file);
                    });
                }
                readFiles([], files);
            });

            input.on('change', function() {
                var files = [];
                for (var i = 0, count = input[0].files.length; i < count; ++i) {
                    files.push(input[0].files[i]);
                }
                readFiles([], files);
            });

            scope.delegateClick = function () {
                input[0].click();
            };
        },
        template:
                '<div class="aqua-form--fileupload"' +
                '   ng-class="{\'aqua-form--fileupload_inline\': type === \'inline\', \'aqua-form--fileupload_compact\': type === \'compact\'}">' +
                '   <div ng-class="{\'grid-5\': type === \'inline\', \'gride-12\': type === \'compact\'}">' +
                '       <div ng-if="!uploader.isUploading">' +
                // missing file
                '           <div class="aqua-form--file grid-middle" ng-if="!currentfile.name">' +
                '               <div class="aqua-form--file--icon aqua-form--file--icon_empty"><icon type="document-empty" size="large"></icon></div>' +
                '               <div class="aqua-form--file--info">' +
                '                   <span class="aqua-form--file--info_name aqua-form--file--info_name_empty">{{label}}</span>' +
                '               </div>' +
                '           </div>' +
                // current file
                '           <a class="aqua-form--file" ng-if="currentfile.name" ng-href="{{currentfile.uri}}" target="_blank">' +
                '               <div class="aqua-form--file--icon"><icon type="{{currentfile.icon}}" size="large"></icon></div>' +
                '               <div class="aqua-form--file--info">' +
                '                   <span class="aqua-form--file--info_name">{{currentfile.name | translate}}</span>' +
                '                   <span class="aqua-form--file--info_date">({{ \'form.updated\' | translate}} <span>{{currentfile.created | date:\'dd/MM/yyyy\'}}</span>)</span>' +
                '               </div>' +
                '           </a>' +
                '       </div>' +
                '       <div ng-if="uploader.isUploading">' +
                // uploading file
                '           <div class="aqua-form--file grid-middle">' +
                '               <div class="aqua-form--file--icon aqua-form--file--icon"><icon type="document-loader" size="large"></icon></div>' +
                '               <div class="aqua-form--file--info">' +
                '                   <span class="aqua-form--file--info_name aqua-form--file--info_name_empty">{{\'form.wait\' | translate}}...</span>' +
                '               </div>' +
                '           </div>' +
                '       </div>' +
                '   </div>' +
                '   <div class="aqua-form--fileupload--field" ng-class="{\'grid-7\': type === \'inline\', \'gride-12\': type === \'compact\'}">' +
                '       <div class="aqua-form--fileupload--field_group">' +
                '           <input class="is-hidden" type="file" />' +
                '           <button '+
                '               class="aqua-form--fileupload--button"' +
                '               ng-click="delegateClick()">{{labeladd}}</button>' +
                '           <div class="aqua-form--dropzone">' +
                '               <span class="aqua-form--dropzone--label">{{\'form.dragdrop\' | translate}}</span>' +
                '           </div>' +
                '       </div>' +
                '       <div class="aqua-form--fileupload--errors" ng-if="$errors.length > 0">' +
                '           <span ng-repeat="error in $errors">{{error.message}}</span>' +
                '       </div>' +
                '   </div>' +
                '</div>'
    }
});
